module.exports = __webpack_public_path__ + "static/media/brammittendorff.6bc28890.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/brammittendorff.webp
// module id = 814
// module chunks = 0